module.exports = __webpack_public_path__ + "img/page1.6aacd4d0.jpg";